<template>
  <div id="contenedor-agregar-subgrupo-obra">
    <v-form v-model="formularioValido" ref="registrarCatalogoSubgrupoObra">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar nuevo Subgrupo de Obra
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            label="Grupo de Obra"
            v-model="catalogoSubgrupoObra.idGrupoObra"
            :items="listadoGruposObras"
            item-text="descripcion"
            item-value="id"
            :rules="[mixReglas.requerido]"
            required
          />
          <custom-text-field
            label="Número"
            v-model="catalogoSubgrupoObra.numero"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <custom-text-field
            label="Descripción"
            v-model="catalogoSubgrupoObra.descripcion"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="guardar"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import mixCatalogoSubgruposObras from './mixCatalogoSubgruposObras';
import mixCatalogoGrupoObra from '../grupos.obras/mixCatalogoGrupoObra';

export default {
  name: 'AgregarCatalogoSubgrupoObra',
  mixins: [mixCatalogoSubgruposObras, mixCatalogoGrupoObra],
  components: {
    CustomButton,
    CustomTextField,
    CustomSelect,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      catalogoSubgrupoObra: {
        idGrupoObra: '',
        numero: '',
        descripcion: '',
      },
    };
  },
  methods: {
    async guardar() {
      await this.mixAgregarCatalogoSubgrupoObra().then(() => {
        this.cerrar();
      });
    },
    clearForm() {
      this.$refs.registrarCatalogoSubgrupoObra.reset();
      this.$refs.registrarCatalogoSubgrupoObra.resetValidation();
      this.catalogoSubgrupoObra = {
        idGrupoObra: '',
        numero: '',
        descripcion: '',
      };
    },
    cerrar() {
      this.clearForm();
      this.$emit('cerrar');
    },
  },
  computed: {
    listadoGruposObras() {
      if (!this.catalogoGruposObras) {
        return [];
      }
      return this.catalogoGruposObras.map((grupoObra) => ({
        descripcion: `${grupoObra.numero} - ${grupoObra.descripcion}`,
        id: grupoObra.id,
      }));
    },
  },
};
</script>

<style lang="scss">

</style>
